module.exports = __webpack_public_path__ + "static/media/logo5.af0d18a3.jpg";